angular.module('unergie.main')
.controller('paymentsCtrl', ($scope, $state, $uibModal, DataAccess, DataAccessSearch, AlertManager, Rules, ApiUser, PaymentService,
    ModalService, TableGeneratorService, ReferencesService, FilterMapping, ErrorCatcher) => {
    ReferencesService.getRef('sepa-error-codes', true).then((mapping) => {
        $scope.sepaErrorsMapping = {}
        _.each(mapping, (m) => {
            $scope.sepaErrorsMapping[m.id] = m
        })
    })

    $scope.payment_status = FilterMapping.paymentStatuses

    $scope.payments = {}
    $scope.payments.refreshing = false

    $scope.payments.columns = {
        id: { label: 'ID', mode: 'search_operator' },
        id_contract: { label: 'Contract ID', mode: 'search_wildcard', length: 9 },
        status: { label: 'Statut', mode: 'search_operator' },
        label: { label: 'Libellé', mode: 'search_wildcard' },
        payment_date: { label: 'Date', mode: 'search_date' },
        rejection_date: { label: 'Date', mode: 'search_date' },
        amount: { label: 'Montant', mode: 'search_operator' },
        mode: { label: 'Mode', mode: 'search_wildcard' },
        type: { label: 'Type', mode: 'search_wildcard' },
        trigger: { label: 'Initiative', mode: 'search_wildcard' },
        rejection_code: { label: 'Code erreur', mode: 'search_wildcard' },
        rejection_lbl: { label: 'Libellé Erreur', mode: 'search_wildcard' },
        external_ref: { label: 'ID slimpay', mode: 'hidden' },
        refund_of: { label: 'ID du paiement partiellement remboursé', mode: 'hidden' },
        refund_of_deposit: { label: 'ID du paiement de dépôt de garantie partiellement remboursé', mode: 'hidden' },
    }

    const refresh = () => TableGeneratorService.getTable($scope.payments, 'payments')

    $scope.payloadProcessPayments = {
        limit: 20,
    }
    $scope.processPaymentFields = {
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
    }

    $scope.payloadRTransOdoo = {
        limit: 20,
    }
    $scope.rTransFields = {
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
    }

    $scope.payloadPaymentOdoo = {
        limit: 100,
    }
    $scope.paymentOdooFields = {
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
    }

    $scope.refundCbPayment = PaymentService.refundCbPayment
    $scope.canRefund = PaymentService.canRefund
    $scope.refundFields = PaymentService.refundFields

    const openResultModal = (result) => ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result: { processed: result.processed, errors: result.errors } })

    $scope.processingPaymentOdoo = false
    $scope.processingRTransOdoo = false

    $scope.processPayment = function () {
        $scope.processingPayment = true
        return Rules.launch({ rule: 'process-payments' }, { limit: $scope.payloadProcessPayments.limit }).$promise.then((result) => {
            AlertManager.success('Batch lancé')
            refresh()
            return openResultModal(result) }).catch(ErrorCatcher)
        .finally(() => {
            $scope.processingPayment = false
        })
    }

    $scope.paymentOdoo = function () {
        $scope.processingPaymentOdoo = true
        return Rules.paymentsOdoo({ limit: $scope.payloadPaymentOdoo.limit, replay: $scope.payloadPaymentOdoo.replay }).$promise.then((result) => {
            AlertManager.success('Batch lancé')
            refresh()
            return openResultModal(result) }).catch(ErrorCatcher)
        .finally(() => {
            $scope.processingPaymentOdoo = false
        })
    }

    $scope.refresh = refresh
    refresh()

    $scope.isActive = (state) => $state.is(state)

    ReferencesService.getRef('paymentStatuses').then((mapping) => {
        $scope.paymentStatuses = mapping
    })

    $scope.changeStatusPayload = {
        status: '',
        rejection_date: moment(),
        rejection_lbl: '',
    }

    $scope.changeStatusFieldsTemplate = {
        status: {
            label: 'Status',
            required: true,
            type: 'select',
            enum: [],
        },
        rejection_date: {
            label: 'Date de refus',
            required: true,
            type: 'datetime',
        },
        rejection_lbl: {
            label: 'Commentaire rejet',
            type: 'text',
        },
    }

    $scope.isModifiable = (payment) => {
        return payment.status === 11 ||
        ([50, 55].includes(payment.status) && ['TRANSFER', 'CHECK', 'ENERGY_CHECK', 'EXTRA'].includes(payment.mode) && !['CIR', 'PERTE'].includes(payment.type)) ||
        (payment.status === 90 && ['SEPA'].includes(payment.mode))
    }

    $scope.prepareChgStatusPayload = (payment) => {
        payment.closeChange = false
        _.each(_.filter($scope.payments.instance.data, (p) => p.id !== payment.id && !p.closeChange), (p) => {
            p.closeChange = true
        })
        $scope.changeStatusFields = _.clone($scope.changeStatusFieldsTemplate)
        if (payment.status === 11) {
            $scope.changeStatusFields.status.enum = [{ label: 'En erreur', value: 90 }]
            delete $scope.changeStatusFields.rejection_date
            delete $scope.changeStatusPayload.rejection_date
        } else if (payment.status === 90) {
            $scope.changeStatusFields.status.enum = [{ label: 'Initial', value: 0 }]
            delete $scope.changeStatusFields.rejection_date
            delete $scope.changeStatusPayload.rejection_date
            delete $scope.changeStatusPayload.rejection_lbl
        } else if (['TRANSFER', 'CHECK', 'ENERGY_CHECK', 'EXTRA'].includes(payment.mode)) {
            $scope.changeStatusFields.status.enum = [{ label: 'Refusé', value: 95 }]
            $scope.changeStatusPayload.rejection_date = moment()
        }
        $scope.changeStatusPayload.status = $scope.changeStatusFields.status.enum[0].value
    }

    $scope.updateStatus = (payment) => {
        payment.modifying = true
        const payload = _.clone($scope.changeStatusPayload)
        payload.rejection_date = payload.rejection_date && moment(payload.rejection_date).toISOString()
        return DataAccess.modifyPaymentStatus({ id_payment: payment.id }, payload).$promise.then(() => {
            AlertManager.success('Statut modifié !')
            refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payment.modifying = false
        })
    }

    $scope.canFetch = (payment) => (payment.status > 0 && payment.status < 98 && ['CB', 'SEPA'].includes(payment.mode))

    $scope.fetchingBankStatus = PaymentService.fetchSlimpayStatus
})
